<template>
  <div class="bg-grey-100 bg-molecules pb-5 pb-lg-8">
    <div class="container">
      <div class="row">
        <!--<div class="col col-12 col-md-6">-->
        <!--  <select aria-controls="#database-entries" class="w-100 mb-2 mb-md-5" v-model="selectedType" @change="setMapBounds(); setMaxPage();">-->
        <!--    <option value="" selected>Type</option>-->
        <!--    <option value="Academic">Academic</option>-->
        <!--    <option value="Company">Company</option>-->
        <!--    <option value="Other">Other</option>-->
        <!--  </select>-->
        <!--</div>-->

        <div class="col col-12 col-md-6">
          <label for="selected-type" class="d-block fw-600 mb-1">Type</label>
          <select aria-controls="#database-entries" name="type" id="selected-type" class="w-100 mb-4" v-model="selectedType" @change="setMapBounds(); setMaxPage(); selectedActivity = '';">
            <option value="" selected>All</option>
            <option v-for="type in types" :value="type.id" :key="type.id">{{ type.name }}</option>
          </select>
        </div>
        <div class="col col-12 col-md-6">
          <label for="selected-activity" class="d-block fw-600 mb-1">Activity</label>
          <select :disabled="selectedType == ''" name="activity" id="selected-activity" aria-controls="#database-entries" class="w-100 mb-4" v-model="selectedActivity" @change="setMapBounds(); setMaxPage();">
            <option value="" selected>All</option>
            <template v-for="activity in activities" :key="activity.name">
              <option v-if="this.selectedType == activity.parent" :value="activity.name">{{ activity.name }}</option>
            </template>
          </select>
        </div>
        <div class="col col-12 col-md-6">
          <label for="keyword" class="d-block fw-600 mb-1">Title</label>
          <input type="search" name="keyword" id="keyword" placeholder="Search titles by keyword" aria-controls="#database-entries" class="w-100" v-model="searchTerm" @input="setMapBounds(); setMaxPage();">
        </div>
        <div class="col col-12 col-md-6">
          <div class="input-wrapper position-relative d-inline-block me-4 mt-5">
            <input aria-controls="#database-entries" type="radio" name="view" v-model="view" id="grid" value="grid"><label for="grid"><i class="fal fa-grid-2 "></i>
            Grid view</label>
          </div>
          <div class="input-wrapper position-relative d-inline-block">
            <input aria-controls="#database-entries" type="radio" name="view" v-model="view" id="map" value="map" @change="setMapBounds"><label for="map"><i class="fal fa-map "></i>
            Map view</label></div>
        </div>
      </div>
    </div>
  </div>
  <div id="database-entries">
    <TransitionGroup name="fade">
      <template v-if="this.filteredEntries.length">
        <section aria-label="Database Entry List" v-if="view == 'grid'">
          <div class="container">
            <div class="row gy-3">
              <template v-for="entry in pagedEntries" :key="entry.id">
                <div class="col col-12 col-md-6 col-lg-4">
                  <EntryCard :entry="entry" />
                </div>
              </template>
              <div class="col-12">
                <div class="pagination d-flex justify-content-center" v-if="maxPage > 1">
                  <button class="button-unstyled mx-half" @click="changePage(currentPage-1)" :class="{invisible : currentPage == 0}" aria-controls="#database-entries">
                    <i class="fal fa-chevron-left"></i></button>
                  <ul class="list-unstyled d-flex " aria-label="Page numbers">
                    <template v-for="i in allPages" :key="i">
                      <li v-if="showPaginationItem(i)" :class="paginationRevealClass(i)">
                        <button class="button-unstyled page-button fw-600 font-size-larger lh-1 text-center rounded-1 mx-half" :class="{'bg-brand-secondary color-white' : this.currentPage == i}" @click="changePage(i)" aria-controls="#database-entries">
                          {{ i + 1 }}
                        </button>
                      </li>
                    </template>
                  </ul>
                  <button class="button-unstyled mx-half" @click="changePage(currentPage+1)" :class="{invisible : currentPage == maxPage-1}" aria-controls="#database-entries">
                    <i class="fal fa-chevron-right"></i></button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="map-section" v-if="view == 'map'" class="py-0">
          <GMapMap
              :center="center"
              :zoom="10"
              map-type-id="terrain"
              style="width: 100vw; height: 80vh"
              ref="map"
              :options="{
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
               clickableIcons: false }">
            <template v-for="entry in filteredEntries" :key="entry.id">
              <GMapMarker
                  :position="entry.coordinates"
                  :clickable="true"

                  @click="openMarker(entry)">
                <GMapInfoWindow
                    :options=" {
              maxWidth: 348,}"
                    :closeclick="true"
                    @closeclick="openMarker(null)"
                    :opened="openedMarkerID === entry.id">

                  <EntryCard :entry="entry" />

                </GMapInfoWindow>
              </GMapMarker>
            </template>
          </GMapMap>
        </section>
      </template>
      <section v-else-if="loading" aria-label="Database entries are loading" class="text-center">
        <i class="fas fa-spinner-third fa-spin fa-3x color-blue"></i>
      </section>
      <section v-else aria-label="No results round">
        <div class="container">
          <div class="row">
            <div class="col col-12">
              <h2 class="color-blue">No results found!</h2>
              <p>Please try a different combination of filters</p>
            </div>
          </div>
        </div>
      </section>
    </TransitionGroup>
  </div>

</template>

<script>
/* global google */
import EntryCard from "@/components/EntryCard";

export default {
  name: 'App', components: {EntryCard}, data() {
    return {
      entries: [],
      types: [],
      activities: [],
      loading: true,
      selectedActivity: "",
      selectedType: "",
      searchTerm: "",
      view: "grid",
      center: {lat: 53.32974, lng: -6.4501},
      openedMarkerID: null,
      currentPage: 0,
      maxPage: 1,
    }
  }, methods: {
    filterEntry: function (entry) {
      if (this.selectedType && entry.type !== this.selectedType) {
        return false
      }

      if (this.selectedActivity && entry.activity !== this.selectedActivity) {
        return false
      }

      if (this.searchTerm && !entry.title.toLowerCase().
          includes(this.searchTerm)) {
        return false
      }
      return true;
    }, openMarker(entry) {
      this.openedMarkerID = (entry ? entry.id : null)
    }, setMapBounds: function () {

      if (this.view !== 'map' || !this.filteredEntries.length) {
        return;
      }

      this.$refs.map.$mapPromise.then((map) => {
        const bounds = new google.maps.LatLngBounds();

        for (let i = 0; i < this.filteredEntries.length; i++) {
          bounds.extend(this.filteredEntries[i].coordinates);
        }

        map.fitBounds(bounds);
        //setZoom was sometimes firing before fitBounds finished, and so wouldn't work. This listener checks for any actions being finished then setting the zoom level
        var listener = google.maps.event.addListener(map,
            "idle",
            function () {
              if (map.getZoom() > 9) map.setZoom(9);
              google.maps.event.removeListener(listener);
            });
      })
    }, setMaxPage: function () {
      this.currentPage = 0;
      this.maxPage = Math.ceil(this.filteredEntries.length / 9);
    },
    changePage: function(i) {
      this.currentPage = i;
      document.getElementById('keyword').scrollIntoView();
    },
    showPaginationItem: function (i) {
      return i == 0 || i == (this.maxPage-1) || (i>=this.currentPage-2 && i<=this.currentPage+2)
    },
    paginationRevealClass: function (i) {
      if (i == 0 && this.maxPage>5 && this.currentPage>3) {
        return 'show-more-pages-after';
      }

      if (i == this.maxPage-1 && this.maxPage > 5 && this.currentPage < this.maxPage-4) {
        return 'show-more-pages-before';
      }
    },

  }, computed: {
    filteredEntries() {
      return this.entries.filter(this.filterEntry);
    }, pagedEntries() {
      const currentPosition = this.currentPage * 9;
      return this.filteredEntries.slice(currentPosition,
          currentPosition + 9);
    }, allPages() {
      let pages = [];
      for (let i = 0; i < this.maxPage; i++) {
        pages[i] = i;
      }
      return pages;
    },
  }, mounted() {
    fetch(database.resturl,
        {
          method: 'GET', credentials: 'same-origin', headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }).
        then((response) => response.json()).
        then((response) => {
          this.entries = response.entries;
          this.types = response.types;
          this.activities = response.activities;
          this.loading = false;
          this.maxPage = Math.ceil(this.entries.length / 9);
        });
  },
}
</script>

<style>
.gm-style-iw {
  width: 348px !important;
  max-width: calc(100vw - 2rem) !important;
  padding-top: 0.5rem !important;
  background-color: #f5f5f5 !important;
}

.gm-style-iw, .gm-style-iw-d {
  max-height: none !important;
}

.gm-style .gm-style-iw-c {
  padding: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

button.gm-ui-hover-effect {
  top: 0 !important;
  right: 0 !important;
}

button.gm-ui-hover-effect span {
  margin: 0 !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
  color: #292929;
}

.gm-style-iw-d {
  overflow: auto !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.page-button {
  width: 2rem;
  height: 2rem;
}
</style>
